export default {"src":"/_next/static/media/xbc.055185c2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};